module.exports = __webpack_public_path__ + "img/trial1-2.b5c38f73.png";